// @aide-description Landing page of the workspace, showing the user's favourite sites, every site they can access, and their recent document activity
// @aide-area My Favourite Sites
// @aide-area Sites
// @aide-area Recent Activity
import React from "react";
import { MaplesPage } from "components/pages";
import { WorkspaceDashboard } from "features/Workspace/WorkspaceDashboard";

const DashboardPage = () => (
  <MaplesPage headerItems={["My Workspace"]}>
    <WorkspaceDashboard />
  </MaplesPage>
);

export default DashboardPage;
